import { Injectable } from '@angular/core';

import { IconsSettingsService } from '@tpt/common/icons/icons';

@Injectable()
export class TiIconSettingsService extends IconsSettingsService {
  private customIcons: { [key: string]: string } = {
    tag: 'fa fa-tag',
    flask: 'fa fa-flask',
    folder: 'far fa-folder-open',
    close: 'fa fa-times-circle',
    warning: 'fa fa-exclamation-triangle',
    'more-vertical': 'fa-solid fa-ellipsis',
    'arrow-e': 'fa fa-caret-right',
    'arrow-w': 'fa fa-caret-left',
  };

  public override getCustomFontIconClass(iconName: string): string {
    return this.customIcons[iconName] || super.getCustomFontIconClass(iconName);
  }
}
